import { render } from "./vrefundapplication.vue?vue&type=template&id=72ef3db6&scoped=true"
import script from "./vrefundapplication.vue?vue&type=script&lang=js"
export * from "./vrefundapplication.vue?vue&type=script&lang=js"

import "./vrefundapplication.vue?vue&type=style&index=0&id=72ef3db6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ef3db6"]])

export default __exports__